import React, { Component } from "react";

export default class AddButton extends Component {
  render() {
    return (
      <div className="row save-btn">
        <div className="float-right">
          <button
            onClick={this.props.onClick}
            className="btn btn-primary"
            id="saving_button"
            type="button"
            style={{
              width: "100px",
              marginRight: "15px",
            }}
          >
            Add
          </button>
        </div>
      </div>
    );
  }
}
